import { useQuery } from '@tanstack/react-query';
import { APITypes } from '../../primary-record-types';
import urls from '../../utils/urls';
import { appAPI } from '../../utils/api';

export type UseFastenRefreshHistoryArgs = {
    medicalProfileId: string;
    orgConnectionId: string;
    enabled?: boolean;
};

export type UseFastenRefreshHistoryResult = {
    isLoading: boolean;
    history: APITypes.ehrIntegrationsService.FastenDataPullHistoryEntry[];
};

export const getFastenRefreshHistoryCacheKey = (medicalProfileId: string, orgConnectionId: string) => [
    'fasten-refresh-history',
    medicalProfileId,
    orgConnectionId,
];

const useFastenRefreshHistory = (args: UseFastenRefreshHistoryArgs): UseFastenRefreshHistoryResult => {
    const { medicalProfileId, orgConnectionId } = args;
    const enabled = args?.enabled !== false;

    const { data, isLoading } = useQuery({
        queryKey: getFastenRefreshHistoryCacheKey(medicalProfileId, orgConnectionId),
        queryFn: async () => {
            const response = await appAPI.get<APITypes.ehrIntegrationsService.FastenDataPullHistoryResponse>(
                urls.api.ehrIntegrations.fasten.endpoints.connections.ingestions(medicalProfileId, orgConnectionId),
            );
            return response;
        },
        enabled: enabled && !!medicalProfileId && !!orgConnectionId,
        staleTime: 1000 * 60 * 5, // 5 minutes
    });

    return {
        isLoading,
        history: data?.history || [],
    };
};

export default useFastenRefreshHistory;
